export default __webpack_public_path__ + "26aa1f7dc21cd75f979f48cb8479a64e.png";